import { createWebHistory, createRouter } from "vue-router"
import { needLogin, hasPermissions, routeNotMatch, requirePermissions, goToPath } from "@/lib/router_utils.ts"

import currentUser from "@/lib/user.ts"

import HomeView from "@/views/main/HomeView/index.vue"
import ForAuthorsView from "@/views/main/ForAuthorsView/index.vue"
import ContactsView from "@/views/main/ContactsView/index.vue"
import EthicalCodeView from "@/views/main/EthicalCodeView/index.vue"
import PublicationsView from "@/views/main/PublicationsView.vue"
import ShowPublicationView from "@/views/main/ShowPublicationView.vue"
import AuthorsView from "@/views/main/AuthorsView.vue"
import ShowArticleView from "@/views/main/ShowArticleView.vue"
import AdvancedSearchView from "@/views/main/AdvancedSearchView.vue"
import AdvancedSearchResultsView from "@/views/main/AdvancedSearchResultsView.vue"
import ConventionsView from "@/views/main/ConventionsView/index.vue"
import PrivacyView from "@/views/main/PrivacyView.vue"
import CookieView from "@/views/main/CookieView.vue"
import PersonalDataView from "@/views/main/PersonalDataView.vue"

const router = createRouter({
  history: createWebHistory(`/${I18n.availableLocales[I18n.locale].prefix}`),
  routes: [
    {
      path: "/",
      name: "root_path",
      component: HomeView
    },
    {
      path: "/for_authors",
      name: "for_authors_path",
      component: ForAuthorsView
    },
    {
      path: "/contacts",
      name: "contacts_path",
      component: ContactsView
    },
    {
      path: "/ethical_code",
      name: "ethical_code_path",
      component: EthicalCodeView
    },
    {
      path: "/publications",
      name: "publications_path",
      component: PublicationsView
    },
    {
      path: "/publications/:id",
      name: "show_publication_path",
      component: ShowPublicationView
    },
    {
      path: "/authors",
      name: "authors_path",
      component: AuthorsView
    },
    {
      path: "/articles/:id",
      name: "show_article_path",
      component: ShowArticleView
    },
    {
      path: "/advanced_search",
      name: "advanced_search_path",
      component: AdvancedSearchView
    },
    {
      path: "/advanced_search_results",
      name: "advanced_search_results_path",
      component: AdvancedSearchResultsView
    },
    {
      path: "/conventions",
      name: "conventions_path",
      component: ConventionsView,
      meta: {
        requiresAuth: true,
        requiredPermissions: ['convention_user_admin']
      }
    },
    {
      path: "/privacy_policy",
      name: "privacy_policy_path",
      component: PrivacyView
    },
    {
      path: "/cookie_policy",
      name: "cookie_policy_path",
      component: CookieView
    },
    {
      path: "/personal_data",
      name: "personal_data_path",
      component: PersonalDataView
    }
  ]
})

router.beforeEach(async (to, _from, next) => {
  if (currentUser.user === null && !currentUser.loading) {
    await currentUser.updateUser()
  }

  if (routeNotMatch(to)) {
    window.location.href = '/'

  } else if (needLogin(to)) {
    window.location.href = '/users/sign_in'

  } else if (requirePermissions(to) && !hasPermissions(to)) {
    goToPath('/')
  } else {
    next()
  }
})

export default router
